import styled from 'styled-components';
import SearchBar from '../../SearchBar';

const StyledSearchBar = styled(SearchBar)`
  margin: 10px 0;
`;

export {
  StyledSearchBar,
};
